// Cart reservation countdown: runs while the cart has items, restarts on every cart change and
// empties the cart when it reaches zero. The deadline is kept in sessionStorage so it survives navigation.
(function () {
  const settings = window.cartCountdownSettings;
  if (!settings || customElements.get('cart-countdown')) return;

  const STORAGE_KEY = 'cart-countdown-deadline';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  let deadline = null;
  let intervalId = null;

  function readDeadline() {
    try {
      return Number(sessionStorage.getItem(STORAGE_KEY)) || null;
    } catch (e) {
      return null;
    }
  }

  function writeDeadline(value) {
    try {
      if (value) sessionStorage.setItem(STORAGE_KEY, value);
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function remaining() {
    return deadline ? Math.max(deadline - Date.now(), 0) : null;
  }

  function tick() {
    const ms = remaining();
    document.dispatchEvent(new CustomEvent('cart-countdown:tick', { detail: { remaining: ms } }));
    if (ms === 0) expire();
  }

  // Qikify Slide Cart renders its drawer client-side, so the countdown is cloned into it from a template
  // (see theme.liquid) and re-inserted whenever the app re-renders the drawer body.
  const drawerTemplate = document.getElementById('cart-countdown-template');
  let mountFrame;

  function mountInAppDrawer() {
    if (!drawerTemplate || !remaining()) return;
    const drawerBody = document.querySelector('.qsc2-drawer-body');
    if (!drawerBody || drawerBody.querySelector(':scope > cart-countdown')) return;
    drawerBody.prepend(drawerTemplate.content.cloneNode(true));
  }

  function run() {
    if (!intervalId) intervalId = setInterval(tick, 1000);
    tick();
    mountInAppDrawer();
  }

  function start() {
    deadline = Date.now() + settings.duration;
    writeDeadline(deadline);
    run();
  }

  function stop() {
    deadline = null;
    writeDeadline(null);
    clearInterval(intervalId);
    intervalId = null;
    tick();
  }

  function expire() {
    stop();
    fetch(`${root}cart/clear.js`, { method: 'POST', headers: { Accept: 'application/json' } })
      .then((response) => {
        // The cart page renders its line items server-side, so reload it to show the empty state.
        if (response.ok && document.querySelector('cart-items')) window.location.reload();
      })
      .catch((e) => console.error(e));
  }

  // Fired by cart-icon-sync.js after any successful /cart/add|change|update|clear request.
  function onCartChanged() {
    fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => (cart.item_count > 0 ? start() : stop()))
      .catch((e) => console.error(e));
  }

  function formatTime(ms) {
    const totalSeconds = Math.ceil(ms / 1000);
    const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');
    return `${minutes}:${seconds}`;
  }

  const storedDeadline = readDeadline();
  if (settings.itemCount === 0) {
    writeDeadline(null);
  } else if (storedDeadline && storedDeadline - Date.now() <= settings.duration) {
    deadline = storedDeadline;
    run();
  } else {
    start();
  }

  document.addEventListener('cart:changed', onCartChanged);
  if (drawerTemplate) {
    new MutationObserver(() => {
      cancelAnimationFrame(mountFrame);
      mountFrame = requestAnimationFrame(mountInAppDrawer);
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && deadline) tick();
  });

  customElements.define(
    'cart-countdown',
    class CartCountdown extends HTMLElement {
      constructor() {
        super();
        this.onTick = (event) => this.render(event.detail.remaining);
      }

      connectedCallback() {
        this.timeElement = this.querySelector('[data-countdown-time]');
        document.addEventListener('cart-countdown:tick', this.onTick);
        this.render(remaining());
      }

      disconnectedCallback() {
        document.removeEventListener('cart-countdown:tick', this.onTick);
      }

      render(ms) {
        if (!ms) {
          this.remove();
          return;
        }
        this.timeElement.textContent = formatTime(ms);
        this.hidden = false;
      }
    }
  );
})();
